import { render } from "./companyBalanceproductsModel.vue?vue&type=template&id=41f794fc"
import script from "./companyBalanceproductsModel.vue?vue&type=script&lang=js"
export * from "./companyBalanceproductsModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__